import { Message, MessageType } from '@/interfaces/app/Message'
import { uid } from '@/util/helpers'

/**
 * Creates App Message with given type
 *
 * @param {string} messageText Text to display
 * @param {MessageType} type MessageType
 *
 * @return {Message}
 */
export default function(messageText: string, type?: MessageType): Message {
  return {
    uid: uid(),
    message: messageText,
    type: type || MessageType.Info,
  }
}
